import { Icon } from "icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "ui";

import { InviteAthleteDialog } from "src/invitations/InviteAthleteDialog";

import { AthleteLimitDialog } from "./AthleteLimitDialog";

interface InviteAthleteToolbarProps {
  athleteCount: number;
  visibleAthleteCount: number;
  athleteLimit: number | null;
  onMutated: () => void;
}

export function InviteAthleteToolbar(props: InviteAthleteToolbarProps) {
  const { t } = useTranslation();
  const [limitDialogOpen, setLimitDialogOpen] = useState(false);
  const isFiltered = props.visibleAthleteCount !== props.athleteCount;

  return (
    <div className="flex items-center gap-3">
      <span className="text-sm font-semibold tabular-nums">
        {props.athleteLimit !== null && !isFiltered
          ? t("athleteLimit.counter", {
              athleteCount: props.athleteCount,
              athleteLimit: props.athleteLimit,
            })
          : t("athletesPage.count", { count: props.visibleAthleteCount })}
      </span>
      {props.athleteLimit !== null && isFiltered ? (
        <span className="text-muted-foreground text-sm">
          {t("athleteLimit.counter", {
            athleteCount: props.athleteCount,
            athleteLimit: props.athleteLimit,
          })}
        </span>
      ) : null}
      {props.athleteLimit !== null &&
      props.athleteCount >= props.athleteLimit ? (
        <>
          <Button
            onClick={() => {
              setLimitDialogOpen(true);
            }}
          >
            <Icon name="tabler-plus" />
            {t("inviteAthlete.trigger")}
          </Button>
          <AthleteLimitDialog
            athleteLimit={props.athleteLimit}
            open={limitDialogOpen}
            onOpenChange={setLimitDialogOpen}
          />
        </>
      ) : (
        <InviteAthleteDialog refresh={props.onMutated} />
      )}
    </div>
  );
}
